// extracted by mini-css-extract-plugin
export default {"block":"General_block__v+1fH","avatarWrap":"General_avatarWrap__Lzg8k"};